// eslint-disable-next-line no-undef
export const BASE_BACKEND_URL = GLOBAL_CONFIG.REACT_APP_APIM_URL;
// eslint-disable-next-line no-undef
export const ENVIRONMENT = GLOBAL_CONFIG.REACT_APP_ENVIRONMENT;

export const ATTACHMENTS_UPLOAD_URL = `${BASE_BACKEND_URL}/ibuy-${ENVIRONMENT}-attachments/attachments`;
export const ATTACHMENTS_POLLING_URL = `${BASE_BACKEND_URL}/ibuy-${ENVIRONMENT}-attachments/attachments/status`;
export const ATTACHMENTS_DELETE_URL = `${BASE_BACKEND_URL}/ibuy-${ENVIRONMENT}-attachments/attachments/delete`;
export const ATTACHMENTS_COPY_URL = `${BASE_BACKEND_URL}/ibuy-${ENVIRONMENT}-attachments/attachments/copy`;
export const ATTACHMENTS_URL = `${BASE_BACKEND_URL}/ibuy-${ENVIRONMENT}-attachments/attachments`;
